import { useDispatch, useSelector } from 'react-redux';
import { getMessagesOfChannelByChannelIdThunk, getUserInChannelByChannelIdThunk, getUserListThunk, getUserMessageByIdthunk, setConnectedUserListReducer, setMessageDetailsReducer, setMsgLoading, setSelectedUserOrChannel, updateUserPrivateMsgStatusThunk } from '../../slices/userSlice';
import UserLists from './UserLists';
import ChannelLists from './ChannelLists';



const CommunicationSidebar = ({ selectedtab, setMenuState }) => {
    const dispatch = useDispatch();

    const fetchDataSequentiallyForChannel = async (data) => {
        try {
          await dispatch(getUserInChannelByChannelIdThunk(data.SK)).unwrap();
          await dispatch(getMessagesOfChannelByChannelIdThunk(data.SK)).unwrap();
          dispatch(setMsgLoading(false));
        } catch (e) {
          console.error(e);
          dispatch(setMsgLoading(false));
        }
    };

    const handleSelectionChange = async (data) => {
        dispatch(setMsgLoading(true));
        dispatch(setSelectedUserOrChannel(data));
        console.log(data, " = selectedUseerrrrrsssssOrChaaannneeellllll");
        if (data.type === "user") {
          dispatch(setMessageDetailsReducer({ userId: data.PK, isRemove: true }));
          // if (newMsgDetailObj[data.PK.S]) { }
          dispatch(getUserMessageByIdthunk(data.PK))
          .unwrap()
          .then(res => { dispatch(setMsgLoading(false)); })
          .catch(err => { dispatch(setMsgLoading(false)); });
          dispatch(updateUserPrivateMsgStatusThunk({ userId: data.PK }));
        } else if (data.type === "channel") {
          // if (newMsgDetailObj[data.SK]) { }
          dispatch(setMessageDetailsReducer({ userId: data.SK, isRemove: true }));
          await fetchDataSequentiallyForChannel(data);
        }
    };

    if(selectedtab === 1){
      return <UserLists handleSelectionChange={handleSelectionChange} /> 
    }
    if(selectedtab === 2){
      return <ChannelLists handleSelectionChange={handleSelectionChange} />
    }
}

export default CommunicationSidebar
